import { Outlet } from 'react-router-dom'
import Header from '../header/header-mobile'
import Footer from '../footer/footer'

function Layout() {
  return (
    <div className=' flex flex-col min-h-[100vh] min-w-[575px]'>
      <Header></Header>
      <Outlet />
      {/* <Footer></Footer> */}
    </div>
  )
}

export default Layout
